export const ModalPara = ({children})=>{
    return(
        <p className="text-[#36454F] text-[15px]">{children}</p>
    )
}